var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6935 12.9733C10.8656 13.0523 11.0595 13.0703 11.2432 13.0245C11.427 12.9786 11.5896 12.8714 11.7043 12.7208L12.0002 12.3333C12.1554 12.1263 12.3567 11.9583 12.5881 11.8425C12.8196 11.7268 13.0748 11.6666 13.3335 11.6666H15.8335C16.2755 11.6666 16.6994 11.8422 17.012 12.1547C17.3246 12.4673 17.5002 12.8912 17.5002 13.3333V15.8333C17.5002 16.2753 17.3246 16.6992 17.012 17.0118C16.6994 17.3243 16.2755 17.4999 15.8335 17.4999C11.8552 17.4999 8.03994 15.9196 5.22689 13.1065C2.41385 10.2935 0.833496 6.47817 0.833496 2.49992C0.833496 2.05789 1.00909 1.63397 1.32165 1.32141C1.63421 1.00885 2.05814 0.833252 2.50016 0.833252H5.00016C5.44219 0.833252 5.86611 1.00885 6.17867 1.32141C6.49123 1.63397 6.66683 2.05789 6.66683 2.49992V4.99992C6.66683 5.25866 6.60659 5.51385 6.49087 5.74527C6.37516 5.9767 6.20716 6.17801 6.00016 6.33325L5.61016 6.62575C5.45718 6.74257 5.34935 6.90874 5.30499 7.09604C5.26063 7.28335 5.28248 7.48023 5.36683 7.65325C6.50573 9.96647 8.37885 11.8372 10.6935 12.9733Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.f7b07e4f819a1ebc94828795b2ed3ae2.svg";
export { ForwardRef as ReactComponent };